import './upload_excel.css';
import React, { useState, useEffect } from 'react';

import { GROWER_EXCEL_UPLOAD } from '../../common/URLs';
import { useNavigate } from 'react-router-dom';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { FILE_NAME_VALIDATION_ERROR, PROD } from "../../common/constants";
import { Container, Card, Button, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { fileNameValidation } from '../../common/commonValidations';
import { toast } from 'react-toastify';
import { loaderService } from '../../common/custom-loader/loader-service';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';

const div_upload_style = {

    top: "10vh",
    left: "29vw"
}

export default function Excel_Upload() {

    const [selectedFile, setSelectedFile] = useState();
    const [uploadDetails, setUploadDetails] = useState();
    const [fileuploadError, setFileuploadError] = useState('');
    const extensionList = ['xls', 'xlsx', 'xlsm'];
    const navigate = useNavigate();
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);
    const [isApiCalled, setIsApiCalled] = useState(false);

    useEffect(() => {
        if (uploadDetails) {setLogModalOpenSubmit(false)
            if (uploadDetails?.data?.isSuccess === true) {
                toast.success(uploadDetails?.data?.message);
                navigate('../dashboard')
            }
           else if (uploadDetails?.data?.isSuccess === false) {
                toast.error(uploadDetails?.data?.message);
            }
            else {
                toast.error(uploadDetails?.data + ": Add relevant file");
            }
        }
    }, [uploadDetails]);

    const handleChange = (e) => {
        setFileuploadError('');
        setSelectedFile(e.target.files[0])
    };

    // const onConfirmSubmit = () => {
    //     handleLogModalCloseSubmit();
    //     getexcelUploadDetails();
    // }

   
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await getexcelUploadDetails();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpenSubmit(false);
            setIsApiCalled(false);
        }
    };

    const onSubmit = (e) => {
        if (selectedFile) {
            const extension = selectedFile.name.split('.').pop().toLowerCase();
            const isXlsFile = !!extension && extensionList.includes(extension);
            if (!isXlsFile) {
                setFileuploadError("Only .xls, .xlsx, .xlsm files are allowed.");
                return;
            }
            else if (selectedFile.name.split('.').length > 2) {
                setFileuploadError("Double extension file detected.");
                return;
            }
            else if (selectedFile.size >= 5000000) {
                setFileuploadError("The file size should be less than 5MB.");
                return;
            }
            else if (fileNameValidation(selectedFile.name)) {
                setFileuploadError(FILE_NAME_VALIDATION_ERROR);
                return;
            }
            else {
                handleLogModalOpenSubmit();
                e.preventDefault();
            }
        }
    };
    function getexcelUploadDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        apiClient
            .post(GROWER_EXCEL_UPLOAD, formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                setUploadDetails(response)
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                setUploadDetails(error?.response)
                loaderService.hideLoader();
            });
    }


    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                        Bulk Upload
                    </Typography>
                    <a style={{ display: "flex", flexDirection: "row" }} href='https://abrplscmsandbox.blob.core.windows.net/stakeholdertemplate/StakeHolderMasterTemplate.xlsm'>
                        <DownloadIcon /> <Typography variant="subtitle1">Download Pre-registration Template.</Typography></a>
                    <Typography variant="subtitle2" mt={2}>Upload Pre-registration file</Typography>
                    <Box mt={1}>
                        <label className="ChooseFileInputAdminPincode">
                            <input style={{ fontSize: '2vh' }} type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => handleChange(e)} name="Bulk_upload" />
                        </label>
                        <Typography variant="subtitle2" fontSize="1.8vh" color="green">(upload only .xls, .xlsx, .xlsm files.File size limit=5MB)</Typography>
                        <Typography variant="subtitle2" fontSize="1.8vh" color="red">{fileuploadError}</Typography>
                    </Box>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={1}>
                        <Button endIcon={<SubmitIcon/>} sx={{ minWidth: 100 }} variant="contained" name="excel_upload" onClick={(e) => onSubmit(e)}>Submit</Button>
                    </Box>
                </CardContent>
            </Card>
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
       
        </>
    );
}